import VAvatar from './index.vue';

export default {
  install: (Vue) => Vue.component('VAvatar', VAvatar),
};
